import { render, staticRenderFns } from "./MesBomList.vue?vue&type=template&id=567710a0&scoped=true&"
import script from "./MesBomList.vue?vue&type=script&lang=js&"
export * from "./MesBomList.vue?vue&type=script&lang=js&"
import style0 from "./MesBomList.vue?vue&type=style&index=0&id=567710a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567710a0",
  null
  
)

export default component.exports